import { jsx as _jsx } from "react/jsx-runtime";
import { GenericHero, HeroWithRichText, StoreHero } from "./variants";
export const Hero = ({ heroProps  })=>{
    switch(heroProps === null || heroProps === void 0 ? void 0 : heroProps.component){
        case "GenericHero":
            return /*#__PURE__*/ _jsx(GenericHero, {
                ...heroProps
            });
        case "CarFinanceHero":
            return /*#__PURE__*/ _jsx(HeroWithRichText, {
                ...heroProps
            });
        case "StoreHero":
            return /*#__PURE__*/ _jsx(StoreHero, {
                ...heroProps
            });
        default:
            return null;
    }
};
